import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageDashboardDossierCredit } from '../model/PageDashboardDossierCredit';

@Injectable({
  providedIn: "root"
})
export class NewDashboardWorkflowService {
  constructor(private _restClientService: RestClientService) {}


  getDossiersWorkflowStatus(
    workflow: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-workflow/dossiers-workflow-status?filter=${filter}&page=${pageIndex}&size=${pageSize}&workflow=${workflow}`
    );
  }

   getDossiersWorkflowByStatus(
    workflow: string,
    state: String,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-workflow/dossiers-workflow-by-status?filter=${filter}&page=${pageIndex}&size=${pageSize}&workflow=${workflow}&state=${state}`
    );
  }

  getDossiersWorkflowEnCours(
    workflow: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-workflow/dossiers-workflow-en-cours?filter=${filter}&page=${pageIndex}&size=${pageSize}&workflow=${workflow}`
    );
  }

  getDossiersWorkflowEnRetard(
    workflow: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-workflow/dossiers-workflow-en-retard?filter=${filter}&page=${pageIndex}&size=${pageSize}&workflow=${workflow}`
    );
  }

  getDossiersWorkflowMiseEnPlace(
    workflow: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-workflow/dossiers-workflow-mise-en-place?filter=${filter}&page=${pageIndex}&size=${pageSize}&workflow=${workflow}`
    );
  }

  getDossiersWorkflowEnCorrection(
    workflow: string,
    filter: string,
    pageIndex: number,
    pageSize: number
  ): any {
    return this._restClientService.load<PageDashboardDossierCredit>(
      `new-dashboard-workflow/dossiers-workflow-en-correction?filter=${filter}&page=${pageIndex}&size=${pageSize}&workflow=${workflow}`
    );
  }
}